exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "site{font-size:120%}site__notification{min-width:auto}site__notification button{display:none}site .build-number{opacity:.54}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/stylus-loader!./client/app/common/admin/site/site.styl
// module id = 54
// module chunks = 1